import { useState } from 'react'

import { FormControl, type IFormikFormControlProps } from './FormControl'
import {
  type IDeprecatedSingleDatePickerProps,
  DeprecatedSingleDatePicker,
} from '../../elements/DeprecatedDatepicker/'

interface IFormSingleDatePickerProps
  extends
    Omit<IFormikFormControlProps, 'children'>,
    Omit<
      IDeprecatedSingleDatePickerProps,
      'id' | 'date' | 'focused' | 'onDateChange' | 'onFocusChange'
    > {
  focused?: boolean
  onChange?: (newDate: moment.Moment) => void
  onBlur?: () => void
  /** Unique identifier for analytics tracking of single date picker interactions. */
  analyticsId?: string
}

export const FormSingleDatePicker = ({
  disabled,
  focused,
  fullWidth,
  helperText,
  id,
  label,
  layout,
  name,
  onChange = () => undefined,
  onPresetChange = () => undefined,
  onBlur = () => undefined,
  required,
  labelIcon,
  labelTooltipAriaLabel,
  labelTooltipMessage,
  analyticsId,
  ...DatepickerProps
}: IFormSingleDatePickerProps) => {
  const [isFocused, setIsFocused] = useState<boolean>(focused)

  return (
    <FormControl
      name={name}
      disabled={disabled}
      id={id}
      label={label}
      layout={layout}
      helperText={helperText}
      required={required}
      fullWidth={fullWidth}
      labelIcon={labelIcon}
      labelTooltipAriaLabel={labelTooltipAriaLabel}
      labelTooltipMessage={labelTooltipMessage}
    >
      {({ value, handleChange, handleBlur, isSubmitting, error }) => (
        <DeprecatedSingleDatePicker
          {...DatepickerProps}
          date={value}
          disabled={isSubmitting || disabled}
          error={error}
          focused={isFocused}
          id={id}
          analyticsId={analyticsId}
          onDateChange={(newDate) => {
            handleChange(newDate)
            onChange(newDate)
          }}
          onPresetChange={(preset) => {
            setIsFocused(false)
            onPresetChange?.(preset)
          }}
          onFocusChange={(arg) => {
            setIsFocused(arg.focused)
            if (!arg.focused) {
              handleBlur()
              onBlur()
            }
          }}
          block={fullWidth}
          required={required}
        />
      )}
    </FormControl>
  )
}
